const nodeSelectors = {
  navItems: '[js-nav="item"]',
  backdrop: '[js-nav="backdrop"]',
  boundBlockLink: '[js-nav="bound-block-link"]',
  mobileNavLink: 'js-nav="mobile-links-outer"',
  mobileNestedNavLink: '[js-nav="mobile-links-inner"]',
  blurTarget: '[js-nav="blur-target"]',
  targetHidden: '[js-nav="target-hidden"]',
};

let elements = {};

const initializeElements = () => {
  elements = {
    announcementBar: document.querySelector(".ecs-announcement-bar"),
    breadcrumbs: document.querySelector(".ecs-mobile__list-breadcrumb"),
    ecsMenuOpen: document.querySelector(".ecs-menu-open"),
    ecsMenuClose: document.querySelector(".ecs-menu-close"),
    ecsMobileLinkList: document.querySelector(".ecs-mobile-link-list-wrapper"),
    ecsHeaderSearchMobile: document.querySelector(".ecs-header__search-mobile"),
    targetBlur: document.querySelector(nodeSelectors.blurTarget),
    targetHidden: document.querySelector(nodeSelectors.targetHidden),
    boundBlockLink: document.querySelectorAll(nodeSelectors.boundBlockLink),
    navItems: document.querySelectorAll(nodeSelectors.navItems),
    backdrop: document.querySelector(nodeSelectors.backdrop),
    mobileImages: document.querySelectorAll(".ecs-header__dropdown__column"),
    mobileNavLink: document.querySelector(".ecs-mobile__list-outer"),
    mobileNestedNavLink: document.querySelector(".ecs-mobile__list-inner"),
    mobileBoundLinks: document.querySelectorAll(".ecs-mobile-link-bound"),
    mobileBreadcrumb: document.querySelector(
      ".ecs-mobile__list-breadcrumb-title"
    ),
    nestedLinksTrigger: document.querySelectorAll(".ecs-inner-link-trigger"),
    boundLinks: document.querySelectorAll(".ecs-mobile-link-bound"),
  };
};

function addEventListeners() {
  elements.ecsMenuOpen.addEventListener("click", openMobileNav);
  elements.ecsMenuClose.addEventListener("click", closeNavMenu);
  elements.breadcrumbs.addEventListener("click", handleBreadcrumbClick);

  elements.boundBlockLink.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      if (elements.mobileBreadcrumb.innerHTML === "Back") {
        openNestedNavMenu(link);
      } else {
        closeNestedNavMenu();
      }
    });
  });

  elements.nestedLinksTrigger.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      toggleNestedSubLinks(trigger);
    });
  });

  elements.navItems.forEach((navItem) => {
    navItem.addEventListener("mouseenter", () => {
      elements.backdrop.classList.add("is-active");
    });

    navItem.addEventListener("mouseleave", removeActive);
  });
}

function openMobileNav() {
  elements.ecsMenuOpen.classList.add("ecs-hidden");
  elements.ecsMenuClose.classList.remove("ecs-hidden");
  elements.ecsHeaderSearchMobile.classList.add("ecs-hidden");
  elements.ecsMobileLinkList.classList.remove("ecs-hidden");
  showMobileLinkList();
  elements.targetBlur.classList.add("ecs-header__blur");
  elements.targetHidden.classList.add("ecs-visually-hidden");
}

function closeNestedNavMenu() {
  elements.mobileBreadcrumb.innerHTML = "Back";
  elements.mobileNavLink.classList.remove("ecs-hidden");
  elements.mobileNestedNavLink.classList.add("ecs-hidden");
  elements.mobileBoundLinks.forEach((boundLink) => {
    boundLink.classList.add("ecs-hidden");
  });
}

function openNestedNavMenu(link) {
  elements.mobileBreadcrumb.innerHTML = link.dataset.title;
  const selectedLink = link.dataset.title;
  elements.mobileNavLink.classList.add("ecs-hidden");
  elements.mobileNestedNavLink.classList.remove("ecs-hidden");
  elements.mobileBoundLinks.forEach((boundLink) => {
    if (boundLink.dataset.binding === selectedLink) {
      boundLink.classList.remove("ecs-hidden");
    }
  });
}

function hideMobileImages() {
  elements.mobileImages.forEach((image) => {
    image.classList.add("ecs-hidden");
  });
}

function showMobileImages() {
  elements.mobileImages.forEach((image) => {
    image.classList.remove("ecs-hidden");
  });
}

function showSelectedNestedLinks(matcher, wrapper) {
  const visibleListItem = Array.from(elements.boundLinks).find((listItem) => {
    return !listItem.classList.contains("ecs-hidden");
  });
  const dropdown = visibleListItem.querySelectorAll(
    ".ecs-header-mobile-nav__dropdown"
  );

  dropdown.forEach((dropdown) => {
    const dropdownChildren = Array.from(dropdown.children);
    dropdownChildren.forEach((child) => {
      if (
        child.hasAttribute("data-bound") &&
        child.getAttribute("data-bound") === matcher
      ) {
        wrapper.classList.remove("ecs-hidden");
      } else {
        child.classList.add("ecs-hidden");
      }
    });
  });
  // const dropdownChildren = Array.from(dropdown.children);
  // dropdownChildren.forEach((child) => {
  //   if (
  //     child.hasAttribute("data-bound") &&
  //     child.getAttribute("data-bound") === matcher
  //   ) {
  //     wrapper.classList.remove("ecs-hidden");
  //   } else {
  //     child.classList.add("ecs-hidden");
  //   }
  // });
}

function toggleNestedSubLinks(trigger) {
  const newTitle = trigger.dataset.title;
  const triggerArrow = trigger.querySelector(".ecs-inner-link-arrow");
  triggerArrow.classList.add("ecs-hidden");
  trigger.classList.add("ecs-inner-link-trigger-inactive");
  const currentBreadcrumb = elements.mobileBreadcrumb.innerHTML;
  const wrapper = trigger.nextElementSibling;

  if (currentBreadcrumb.includes(' / ')) {
    const lastSlashIndex = currentBreadcrumb.lastIndexOf("/");
    if (lastSlashIndex !== -1) {
      elements.mobileBreadcrumb.innerHTML = currentBreadcrumb.slice(0, lastSlashIndex);
    } else {
      elements.mobileBreadcrumb.innerHTML = currentBreadcrumb;
    }
  } else {
    elements.mobileBreadcrumb.innerHTML = `${currentBreadcrumb} / ${newTitle}`;
  }

  showSelectedNestedLinks(newTitle, wrapper);
  hideMobileImages();
}

function reverseNestedSubLinks() {
  const currentBreadcrumb = elements.mobileBreadcrumb.innerHTML;
  const firstWord = currentBreadcrumb.split(" / ")[0];
  elements.mobileBreadcrumb.innerHTML = firstWord;

  const visibleListItem = Array.from(elements.boundLinks).find((listItem) => {
    return !listItem.classList.contains("ecs-hidden");
  });
  const dropdown = visibleListItem.querySelectorAll(
    ".ecs-header-mobile-nav__dropdown"
  );

  dropdown.forEach((item) => {

  const dropdownChildren = Array.from(item.children);
    dropdownChildren.forEach((child) => {
      child.classList.remove("ecs-hidden");
    });
  });

  const nestedLinkWrappers = document.querySelectorAll(
    ".ecs-nested-link-wrapper"
  );
  const triggers = document.querySelectorAll(".ecs-inner-link-trigger");
  nestedLinkWrappers.forEach((wrapper) => {
    wrapper.classList.add("ecs-hidden");
  });
  triggers.forEach((trigger) => {
    const triggerArrow = trigger.querySelector(".ecs-inner-link-arrow");
    trigger.classList.remove("ecs-inner-link-trigger-inactive");
    triggerArrow.classList.remove("ecs-hidden");
  });
  showMobileImages();
}

function handleBreadcrumbClick() {
  const currentBreadcrumb = elements.mobileBreadcrumb.innerHTML;

  if (currentBreadcrumb.includes("/")) {
    reverseNestedSubLinks();
  } else {
    closeNestedNavMenu();
  }
}

function closeNavMenu() {
  const currentBreadcrumb = elements.mobileBreadcrumb.innerHTML;

  if (currentBreadcrumb.includes("/")) {
    reverseNestedSubLinks();
  }
  elements.ecsMenuOpen.classList.remove("ecs-hidden");
  elements.ecsMenuClose.classList.add("ecs-hidden");
  elements.ecsHeaderSearchMobile.classList.remove("ecs-hidden");
  elements.ecsMobileLinkList.classList.toggle("ecs-hidden");
  closeNestedNavMenu();
  hideMobileLinkList();
  elements.targetBlur.classList.remove("ecs-header__blur");
  elements.targetHidden.classList.remove("ecs-visually-hidden");
}

function removeActive() {
  elements.backdrop.classList.remove("is-active");
}

function showMobileLinkList() {
  if (elements.announcementBar) {
    elements.announcementBar.style.display = "none";
  }
  elements.ecsMobileLinkList.classList.add("show");
  document.documentElement.classList.add("ecs-body-no-scroll");
  document.body.classList.add("ecs-body-no-scroll");
}

function hideMobileLinkList() {
  if (elements.announcementBar) {
    elements.announcementBar.style.display = "block";
  }
  elements.ecsMobileLinkList.classList.remove("show");
  document.documentElement.classList.remove("ecs-body-no-scroll");
  document.body.classList.remove("ecs-body-no-scroll");
}

document.addEventListener("DOMContentLoaded", function () {
  initializeElements();
  addEventListeners();
});
